module.exports = __webpack_public_path__ + "static/media/logo.1e830551.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 24
// module chunks = 0